import { Input, Span } from './styles'
import { useState, useEffect } from 'react'

interface ThaiBathInputProps {
  disabled?: boolean
  value?: number | string
  onChange?: (value: number) => void
  placeholder?: string
}

// TODO implement handle valid value
// TODO required
function ThaiBathInput({ disabled, value, onChange, placeholder = '0.00' }: ThaiBathInputProps) {
  const [inputValue, setInputValue] = useState('')
  const [isFocused, setIsFocused] = useState(false)
  const moneyFormat = new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })

  // Update input value when external value changes (e.g., from form initialization)
  useEffect(() => {
    if (value !== undefined && value !== null && !isFocused) {
      setInputValue(value.toString())
    }
  }, [value, isFocused])

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const rawValue = e.target.value

    // Allow empty input
    if (rawValue === '') {
      setInputValue('')
      if (onChange) {
        onChange(0)
      }
      return
    }

    // Remove any non-numeric characters except decimal point
    const cleanValue = rawValue.replace(/[^0-9.]/g, '')

    // Prevent multiple decimal points
    const parts = cleanValue.split('.')
    const formattedValue = parts.length > 2 ? `${parts[0]}.${parts.slice(1).join('')}` : cleanValue

    // Update input display value
    setInputValue(formattedValue)

    // Parse to number for onChange callback
    const numericValue = parseFloat(formattedValue) || 0
    if (onChange) {
      onChange(numericValue)
    }
  }

  const handleFocus = () => {
    setIsFocused(true)
  }

  const handleBlur = (e: React.FocusEvent<HTMLInputElement>) => {
    setIsFocused(false)

    // Format to 2 decimal places on blur only if there's a value
    if (e.target.value && !isNaN(parseFloat(e.target.value))) {
      const numValue = parseFloat(e.target.value)
      const formattedValue = numValue.toFixed(2)
      setInputValue(formattedValue)

      // Ensure onChange is called with the formatted value
      if (onChange) {
        onChange(numValue)
      }
    }
  }

  // Use inputValue when focused, formatted value when not focused
  const displayValue = isFocused
    ? inputValue
    : inputValue && !isNaN(parseFloat(inputValue))
    ? moneyFormat.format(parseFloat(inputValue))
    : inputValue

  return (
    <>
      <Input
        placeholder={placeholder}
        disabled={disabled}
        value={displayValue}
        onChange={handleChange}
        onFocus={handleFocus}
        onBlur={handleBlur}
      />
      <Span>บาท</Span>
    </>
  )
}

export default ThaiBathInput
